module.exports = __webpack_public_path__ + "img/logo-text.57f54f2a.png";